import { render, staticRenderFns } from "./ManualView.vue?vue&type=template&id=53382d16&scoped=true"
import script from "./ManualView.vue?vue&type=script&lang=js"
export * from "./ManualView.vue?vue&type=script&lang=js"
import style0 from "./ManualView.vue?vue&type=style&index=0&id=53382d16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53382d16",
  null
  
)

export default component.exports